export var CardType;
(function (CardType) {
    CardType["VISA"] = "visa";
    CardType["MASTERCARD"] = "mastercard";
    CardType["AMEX"] = "amex";
    CardType["AMERICAN_EXPRESS"] = "americanexpress";
    CardType["DISCOVER"] = "discover";
    CardType["JCB"] = "jcb";
    CardType["UNKNOWN"] = "unknown";
})(CardType || (CardType = {}));
export var BillingInfoText;
(function (BillingInfoText) {
    BillingInfoText["DayBankDaysText"] = "Day Bank Days";
})(BillingInfoText || (BillingInfoText = {}));
export const CARD_TYPES = {
    [CardType.VISA]: "/Assets/images/cc-visa.png",
    [CardType.MASTERCARD]: "/Assets/images/cc-mastercard.png",
    [CardType.AMEX]: "/Assets/images/cc-amex.png",
    [CardType.AMERICAN_EXPRESS]: "/Assets/images/cc-amex.png",
    [CardType.DISCOVER]: "/Assets/images/cc-discover.png",
    [CardType.JCB]: "/Assets/images/cc-jcb.png",
    [CardType.UNKNOWN]: "/Assets/images/cc-default.png",
};
/**
 * Returns the image for the card brand or a default image if one cannot be found
 *
 * @param brand
 * @returns
 */
export function getCardImage(brand) {
    return !!brand && CARD_TYPES[brand.toLowerCase()] || "/Assets/images/cc-default.png";
}
